import TableService from '../../../services/TableService';

const GROUPED_URL = 'equipamentos/filtro/grouped';

const normalizeGrupo = (row) => ({
  ...row,
  unidades: row.unidades || [],
  quantidade: row.quantidade ?? (row.unidades ? row.unidades.length : 0),
  contagemComEletropontes: row.contagemComEletropontes ?? 0,
  contagemComColaborador: row.contagemComColaborador ?? 0,
});

export async function fetchEquipamentosGrouped(page, pageSize, filterData) {
  const response = await TableService.request(
    `${GROUPED_URL}?p=${page}&s=${pageSize}`,
    filterData
  );
  const rows = (response?.data?.rows || []).map(normalizeGrupo);
  return {
    rows,
    totalRows: response?.data?.totalRows ?? rows.length,
  };
}
